var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { useEffect, useState } from 'react';
export var DesignsContext = React.createContext({
    getDesign: function (path) { return ({}); },
});
export var DesignsContextProvider = function (_a) {
    var product = _a.product, designs = _a.designs, children = _a.children;
    var _b = useState(designs), state = _b[0], setState = _b[1];
    useEffect(function () {
        setState(designs);
    }, [product, designs]);
    var getDesign = function (path) { return (path ? state[path] || {} : {}); };
    return _jsx(DesignsContext.Provider, __assign({ value: { getDesign: getDesign } }, { children: children }));
};
